/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import { useField } from 'formik';
import styled from 'styled-components';
import { Label } from './Label';
import { ErrorMessage } from './ErrorMessage';

export const TextArea = ({ label, ...props }) => {
  // useField() returns [formik.getFieldProps(), formik.getFieldMeta()]
  // which we can spread on <function > and alse replace ErrorMessage entirely.
  const [field, meta] = useField(props);

  return (
    <InputContainer>
      <Label htmlFor={props.id || props.name}>{label}</Label>
      <InputStyles {...field} {...props} />
      {meta.touched && meta.error ? (
        <ErrorMessage>{meta.error}</ErrorMessage>
      ) : null}
    </InputContainer>
  );
};

const InputStyles = styled.textarea`
  padding: 1rem;
  border-radius: 5px;
  min-height: 150px;
  font-size: 1.6rem;
  border: 1px solid var(--darkGrey);
`;

const InputContainer = styled.div`
  display: flex;
  flex-direction: column;
`;
